export default __webpack_public_path__ + "static/dinoMascot-5e66283d3ed3bb9fe8471048303220c0.svg";